import React from "react";

const ONLINE_MAIN_LIGHT = "online-main-light";
const ONLINE_LEFT_LIGHT = "online-left-light";
const ONLINE_RIGHT_LIGHT = "online-right-light";
const MAINTENANCE_LIGHT = "maintenance-light";
const UNAVAILABLE_LIGHT = "unavailable-light";

export {
  ONLINE_MAIN_LIGHT,
  ONLINE_LEFT_LIGHT,
  ONLINE_RIGHT_LIGHT,
  MAINTENANCE_LIGHT,
  UNAVAILABLE_LIGHT
};

export default () => {
  return <svg className="invisible" />;
};



// WEBPACK FOOTER //
// ./src/svg/DefinitionSVG.js